import type { CSSProperties, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  tone?: 'neutral' | 'brand' | 'good' | 'warn' | 'bad';
  size?: 'sm' | 'md';
  icon?: ReactNode;
  style?: CSSProperties;
}

export function Pill({ children, tone = 'neutral', size = 'sm', icon, style }: Props) {
  const tones = {
    neutral: { bg: 'var(--bg-sunken)', fg: 'var(--ink-2)', bd: 'var(--line)' },
    brand: { bg: 'var(--brand-soft)', fg: 'var(--brand-ink)', bd: 'transparent' },
    good: { bg: 'color-mix(in oklab, var(--good) 14%, var(--bg-elev))', fg: 'var(--good)', bd: 'transparent' },
    warn: { bg: 'color-mix(in oklab, var(--warn) 16%, var(--bg-elev))', fg: 'var(--warn)', bd: 'transparent' },
    bad: { bg: 'color-mix(in oklab, var(--bad) 14%, var(--bg-elev))', fg: 'var(--bad)', bd: 'transparent' },
  } as const;
  const t = tones[tone] ?? tones.neutral;
  const sz = size === 'md' ? { padding: '4px 10px', fontSize: 12 } : { padding: '2px 8px', fontSize: 11 };
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        background: t.bg,
        color: t.fg,
        border: `1px solid ${t.bd}`,
        borderRadius: 'var(--r-pill)',
        fontWeight: 500,
        lineHeight: 1.4,
        letterSpacing: '0.01em',
        ...sz,
        ...style,
      }}
    >
      {icon}
      {children}
    </span>
  );
}
